module.exports = __webpack_public_path__ + "assets/vbulletin.96dcccd7.svg";